export const formatKycStatus = (status?: string): string => {
  if (!status) return '—';

  if (status.includes('_')) {
    return status
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  return status.charAt(0).toUpperCase() + status.slice(1);
};
